/**
 * Registry de flujos de onboarding (F1 plan Persona Moral).
 *
 * El shell resuelve el `OnboardingFlow` por `partyType` en vez de conocer los
 * pasos hardcoded. Los flows (FisicaOnboardingFlow, MoralOnboardingFlow) se
 * registran al arranque del app.
 *
 * Vive en `@tankef/core-react` (no en `@tankef/core`) para coincidir con la
 * capa que consume el shell; la abstracción en sí (`OnboardingFlow`) es pura y
 * vive en `@tankef/core`.
 */
import type { OnboardingFlow, PartyTypeFE } from '@tankef/core';

export class OnboardingFlowRegistry {
  private flows = new Map<PartyTypeFE, OnboardingFlow>();

  /** Registra un flow (idempotente: re-registrar sobre-escribe). */
  register(flow: OnboardingFlow): void {
    this.flows.set(flow.partyType, flow);
  }

  /** Resuelve el flow por partyType. Lanza si no hay uno registrado. */
  resolve(partyType: PartyTypeFE): OnboardingFlow {
    const flow = this.flows.get(partyType);
    if (!flow) {
      throw new Error(
        `[OnboardingFlowRegistry] No hay flow registrado para partyType=${partyType}`
      );
    }
    return flow;
  }

  /** ¿Hay un flow registrado para este partyType? */
  has(partyType: PartyTypeFE): boolean {
    return this.flows.has(partyType);
  }
}

/** Singleton registrado al arranque del app (registry.register(fisicaFlow)). */
export const onboardingFlowRegistry = new OnboardingFlowRegistry();
